// extracted by mini-css-extract-plugin
export var carouselWrapper = "examples-list-module--carousel-wrapper--I04yW";
export var carousel = "examples-list-module--carousel--j1YEg";
export var wrapper = "examples-list-module--wrapper--3ZA28";